import moment from 'moment'
import {
  formatAddress,
  formatName,
  formatPhoneNumber,
} from '../../../../../helpers/ordersUtiles'
import { getComp } from '../../../../../utils/utils/DI'
import { RequestType } from '../../../components/SingleRequest/types/Request.type'

export const getCorrectRequestTableValue = (
  key: keyof RequestType,
  el: RequestType,
) => {
  const dealersStore = getComp('DealersStore')
  let value = el[key]

  if (key === 'dealer') {
    value = dealersStore.getDealerName(el[key]) ?? '-'
  }

  if (['installationDate', 'created'].includes(key))
    value = value ? moment(value as string).format('DD.MM.YYYY') : '-'

  if (key === 'locality') value = formatAddress(el, false)

  if (key === 'name') value = formatName(el)
  if (key === 'phone') value = el.phone ? formatPhoneNumber(el.phone) : '-'

  return key === 'id' ? String(value).padStart(6, '0') : value
}

export const getBackgroundColor = (order: RequestType) => {
  switch (order.dataCheckingStatus) {
    case 1:
      return 'rgba(22,176,37,0.3)'
    case 2:
      return 'rgba(224,23,23,0.25)'
    case 3:
      return 'rgba(224,96,23,0.3)'

    default:
      return undefined
  }
}
